import React, { useContext } from 'react'
import { Button, Text, View, useWindowResizeSensor } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Footer from 'src/components/Footer'
import ThemeContext, { Theme } from 'src/libraries/contexts/Theme'
import { useMe, useOrganization } from 'src/graphql/hooks'

// =======================================================
// Layout
// =======================================================

const HomeContainerLayout3 = ({ organizationOverride }) => {
   const theme = useContext(ThemeContext)
   const { currentBreakpoint } = useWindowResizeSensor()
   const { organization: savedOrganization } = useOrganization()
   const { isLoggedIn, loading: userIsLoading } = useMe()

   const organization = organizationOverride
      ? { ...savedOrganization, ...organizationOverride }
      : savedOrganization

   return (
      <>
         <Theme globalNavBorderColor="transparent" />
         <View
            width="100%"
            paddingTop={theme.viewportMarginTop}
            paddingLeft={theme.viewportMarginLeft}
            paddingRight={theme.viewportMarginRight}>
            <View
               display="flex"
               justifyContent="center"
               width="100%">
               <View
                  width="100%"
                  maxWidth={theme.viewportContentMaxWidth}
                  paddingRight={currentBreakpoint !== 'a' && theme.viewportPaddingRight}
                  paddingLeft={currentBreakpoint !== 'a' && theme.viewportPaddingLeft}
                  marginBottom="60px">
                  <View
                     float="left"
                     width="100%"
                     style={{ overflow: 'hidden' }}>
                     <View
                        display="block[a-c] none[d-f]"
                        float="left"
                        width="100%[a-c] 60%[d-f]"
                        paddingTop="75%[a-b] 60%[c]"
                        backgroundColor="#000"
                        backgroundSize="cover"
                        backgroundImage={organization.coverMedia && `url(${organization.coverMedia.file.thumbnailUrlW1600})`}
                        backgroundPosition="centre center"
                     />
                     <View
                        position="relative"
                        float="left"
                        width="100%"
                        paddingTop="56.25%[d] 65%[e-f]"
                        backgroundColor="#000"
                        backgroundSize="cover"
                        backgroundImage={organization.coverMedia && `url(${organization.coverMedia.file.thumbnailUrlW1600})`}
                        backgroundPosition="centre center"
                        style={{ overflow: 'hidden' }}>
                        <View
                           display="flex"
                           justifyContent="flex-end"
                           alignItems="center"
                           position="absolute[d-f]"
                           top="0px"
                           left="0px"
                           width="100%"
                           height="100%[d-f]">
                           <View
                              width="100%[a-c] 40%[d] 45%[e-f]"
                              padding="30px[a] 30px[b] 60px[c] 60px[d] 72px[e-f]"
                              margin="36px[d] 60px[e-f]"
                              borderRadius="2px"
                              backgroundColor="#e06c1d">
                              <View float="left" width="100%">
                                 <Text
                                    letterSpacing="-0.25px"
                                    size="7[a] 8[b] 8[c] 7[d] 8[e-f]"
                                    weight="medium"
                                    color="#fff">
                                    {organization.tagline}
                                 </Text>
                              </View>
                              <View float="left" width="100%" height="18px[a-c] 24px[d] 24px[e-f]" />
                              <View
                                 float="left"
                                 width="42px[a-b] 48px[c-f]"
                                 height="6px[a-c] 6px[d-f]"
                                 backgroundColor="#fde506"
                              />
                              <View float="left" width="100%" height="18px[a-c] 24px[d] 24px[e-f]" />
                              <View float="left" width="100%">
                                 <Text
                                    lineHeight="140%[a-b] 140%[c] 140%[d] 150%[e-f]"
                                    size="2[a-b] 2.5[c] 2[d] 2.5[e-f]"
                                    color="#fff"
                                    style={{ opacity: 0.7 }}>
                                    {organization.description}
                                 </Text>
                              </View>
                              <View
                                 float="left"
                                 width="100%"
                                 height="24px"
                                 borderBottom="1px solid rgba(255,255,255,0.2)"
                                 marginBottom="24px"
                              />
                              <View
                                 float="left[a-b] right[c-f]"
                                 width="100%[a-b]">
                                 {!userIsLoading && !isLoggedIn && (
                                    <Link to="/login">
                                       <Button
                                          size="md[a-c] sm[d] md[e-f]"
                                          width="100%[a-b] auto[c-f]"
                                          color="#fff"
                                          name="Sign In"
                                          outline
                                       />
                                    </Link>
                                 )}
                                 <View float="left" width="3px" height="6px">
                                    &nbsp;
                                 </View>
                                 <Link to="/explore">
                                    <Button
                                       size="md[a-c] sm[d] md[e-f]"
                                       width="100%[a-b] auto[c-f]"
                                       color="rgba(255,255,255,0.2)"
                                       name="Explore"
                                    />
                                 </Link>
                              </View>
                           </View>
                        </View>
                     </View>
                  </View>
               </View>
            </View>
            <Footer backgroundColor="#222" />
         </View>
      </>
   )
}

HomeContainerLayout3.propTypes = {
   organizationOverride: PropTypes.object
}

HomeContainerLayout3.defaultProps = {
   organizationOverride: undefined
}

export default HomeContainerLayout3
